/** Painel de absenteísmo — integração com a API. Só leitura. */

import apiClient from './apiClient';
import type { PainelDeAbsenteismo } from '../types/absenteeism';

export * from '../types/absenteeism';

export const absenteeismService = {
  async painel(periodo?: { inicio: string; fim: string }): Promise<PainelDeAbsenteismo> {
    const query = periodo ? `?inicio=${periodo.inicio}&fim=${periodo.fim}` : '';
    const { data } = await apiClient.get<PainelDeAbsenteismo>(`/absenteismo/painel${query}`);
    if (!data) throw new Error('Resposta vazia do servidor ao montar o painel');
    return data;
  },
};

export default absenteeismService;
